import { styled } from '@mui/material';

import { Paper, PaperProps } from '../paper';

/** @deprecated `Card` is deprecated — use `Panel` / `ChoicePanel` instead. */
export type CardProps = PaperProps;

/**
 * @deprecated Use `LayoutCard` from `@cast/design-system` when card is displayed on the page background.
 * Otherwise, use `Panel` from `@cast/design-system`. Keep in mind that `Panel` doesn't have a padding.
 */
export const Card = styled(Paper)<CardProps>({
  padding: '0px 24px',
  width: '100%',
}) as typeof Paper;
